import React from "react";
import { env } from '../../env';
import { Divider } from "antd";
import "./Animal.scss";
import '../../scss/components/buttons.scss';
import '../../scss/style.scss'
import axios from "axios";
import Data from './animals.json';
import { pathogen } from './pathogen.js';
import scientific from "./pscientific.json"
import { disease } from "./disease";
import { fungi } from "./pathdata";
import { bacteria } from "./pathdata";
import { virus } from "./pathdata";

const urlParams = new URLSearchParams(window.location.search);

const id = urlParams.get("id");

let fd = Data.filter(function (i) {
  // // console.log(i)
  return i.id === id;
});

export default class Animal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      species: fd[0].name,
      pathogen: fd[0].pathogen[0],
      disease: 'Select a Disease',
      hostMap: {},
      currentPathogens: fd[0].pathogen,
      diseaseMap: {},
      currentdisease: [],
      idType: 'host',
      keyword: '',
      annotType: 'go',
      genes: '',
      searchType: 'protein',
      hasExecuted: false,
      expressionExists: false,
    };

    const hostMap = {}
    for (let host of Data) {
      hostMap[host.name] = host.pathogen
    }
    const diseaseMap = {}

    for (let host of Data) {
      diseaseMap[host.name] = host.disease
    }

    this.state.hostMap = hostMap
    this.state.diseaseMap = diseaseMap

    this.handleSpecies = this
      .handleSpecies
      .bind(this);
    this.handlePathogen = this
      .handlePathogen
      .bind(this);
    this.handleDisease = this
      .handleDisease
      .bind(this);
    this.setGeneHint = this.setGeneHint.bind(this);
  }
  setGeneHint(hint) {
    this.setState({ geneHintOn: hint });
  }

  handleSpecies(e) {
    // console.log(e.target.value)
    const species = e.target.value
    if (species === '') {
      this.setState({
        species: '',
        currentPathogens: [],
        currentdisease: []
      })
      return
    }
    const pathogen = this.state.hostMap[species][0];
    this
      .checkExpression(e.target.value, pathogen)
      .then(res => {
        this.setState({
          species: e.target.value,
          currentPathogens: this.state.hostMap[species],
          currentdisease: this.state.diseaseMap[species],
          pathogen: pathogen,
          expressionExists: res,
        });
    });
  }

  handlePathogen(e) {
    this
      .checkExpression(this.state.species, e.target.value)
      .then(res => {
        this.setState({
          pathogen: e.target.value,
          expressionExists: res,
        })
    });
  }

  handleDisease(e) {
    this.setState({
      disease: e.target.value
    })
  }

  async checkExpression(chost, pathogen) {
    const shost = Data.find(host => host.name === chost)['sname'].replace(' ', '_');
    const url = `${env.BACKEND}/api/expression/checkFolderExists?folder=${shost}_${pathogen}`;
    return axios
      .get(url)
      .then((res) => {
        return res.data.exists;
      });
  }

  render() {
    localStorage.setItem(
      "param",
      JSON.stringify({
        host: this.state.species,
        pathogen: this.state.pathogen,
        searchType:this.state.searchType,
        idType:this.state.idType,
        keyword:this.state.keyword,
        genes:this.state.genes,
        annotType:this.state.annotType,
        expressionExists: this.state.expressionExists,
      })
    );
    this.checkExpression(this.state.species, pathogen);

    const ddata = disease[`${this.state.species}_${this.state.pathogen}`]
    const shost = Data.find(host => host.name === this.state.species)['sname'].replace(' ', '_');
    return (
      <div className="container">


        <div className="row mt-2">
          <Divider />
          <div className="col-md-6">
            <h4>Host:&nbsp;&nbsp; {this.state.species}</h4>
          </div>
          <div className="col-md-3 ">
            <h5>OR select other species:</h5>
          </div>
          <div className="col-md-3">

            <select className="form-select ditem" onChange={this.handleSpecies} defaultValue={this.state.species}>
              {/* <option value={fd[0].name}>{fd[0].sname}</option> */}
              {Data.map((sp, index) => {
                return (
                  <option key={index} value={sp.name}>
                    {sp.sname}
                  </option>
                )
              })}
            </select>
          </div>
          <Divider />
        </div>

        <div className="row  mb-4">
          <div className="col-md-6 ">
            <h4>Pathogen: &nbsp;&nbsp; <i>{pathogen[this.state.pathogen]}</i></h4>
          </div>
          <div className="col-md-3 ">
            <h5>OR select other species:</h5>
          </div>
          <div className="col-md-3">
            <select className="form-select ditem" onChange={this.handlePathogen} defaultValue={this.state.currentPathogens[0]}>
              <optgroup label="Fungi" hidden={this.state.currentPathogens.filter(sp => fungi.includes(sp)).length === 0}>
                {this.state.currentPathogens.map((sp, index) => {
                  if (fungi.includes(sp)) {
                    return (
                      <option key={index} value={sp} className="op">
                        {pathogen[sp]}

                      </option>
                    );
                  }
                  else {
                    return ''
                  }
                })}
              </optgroup>
              <optgroup label="Bacteria" hidden={this.state.currentPathogens.filter(sp => bacteria.includes(sp)).length === 0}>
                {this.state.currentPathogens.map((sp, index) => {
                  if (bacteria.includes(sp)) {
                    return (
                      <option key={index} value={sp} style={{ fontStyle: 'italic' }}>
                        {pathogen[sp]}
                      </option>
                    );
                  }
                  else {
                    return ''
                  }
                })}
              </optgroup>
              <optgroup label="Virus" hidden={this.state.currentPathogens.filter(sp => virus.includes(sp)).length === 0}>
                {this.state.currentPathogens.map((sp, index) => {
                  if (virus.includes(sp)) {
                    return (
                      <option key={index} value={sp} style={{ fontStyle: 'italic' }}>
                        {pathogen[sp]}

                      </option>
                    );
                  }
                  else {
                    return ''
                  }
                })}
              </optgroup>

            </select>
          </div>
        </div>


        <Divider />
        <div className="row  mb-4">
          <div className="col-md-6 ">
            <h4>Disease: {ddata} </h4>
          </div>
          <div className="col-md-6 ">
            <h4>Pathogen Type: {scientific[0][`${this.state.pathogen}`][0]} </h4>
          </div>
        </div>

        <Divider />
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="card cardd mb-3">
              <h5 className="heading">Scientific Classification</h5>
              <div className="row text-left cr">
                <div className="col-md-4">
                  <ul className="list list-inline ">
                    <li>Kingdom: </li>
                    <li>Division: </li>
                    <li>Class: </li>
                    <li>Order:</li>
                    <li>Family: </li>
                    <li>Genus: </li>
                    <li>Species: </li>
                  </ul>
                </div>
                <div className="col-md-8">
                  <ul className="list list-inline ">
                    {scientific[0][`${this.state.pathogen}`].map((sp, index) => {
                      if (index !== 6) {
                        return (<li key={index}>{sp}</li>)
                      }
                      else {
                        return (<li className="scname" key={index}>{sp}</li>)
                      }
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card cardd mb-3">
              <h5 className="heading">Pathogen Annotations </h5>
              <ul className="list list-inline cr ">
                <li>
                  <a className="linked" href={`${env.BASE_URL}/kegg/?id=${this.state.pathogen}&class=pathogen`}>
                    KEGG Pathways
                  </a>
                </li>
                <li>
                  <a className="linked" href={`${env.BASE_URL}/go/?id=${this.state.pathogen}&class=pathogen`}>
                    Gene Ontology
                  </a>
                </li>

                <li>
                  <a className="linked" href={`${env.BASE_URL}/interpro/?id=${this.state.pathogen}&class=pathogen`}>
                    Functional Domains
                  </a>
                </li>
                <li>
                  <a className="linked" href={`${env.BASE_URL}/local/?id=${this.state.pathogen}&class=pathogen`}>
                    Subcellular Localization
                  </a>
                </li>
                <li>
                  <a className="linked" href={`${env.BASE_URL}/virulence/?id=effector_and_secretory&species=${this.state.pathogen}`}>
                    Effector and Secretory Proteins
                  </a>
                </li>
              </ul>
            </div>
            {this.state.expressionExists && (
              <a className="btn kbl-btn-1" href={`${env.BASE_URL}/expression/${shost}/${this.state.pathogen}`} >
                Check interaction expression
              </a>
            )}
          </div>

          <div className="col-md-3">
            <div className="card cardd mb-3">
              <h5 className="heading">Host Annotations </h5>

              <ul className="list list-inline cr">
                <li>
                  <a className="linked" href={`${env.BASE_URL}/kegg/?id=${this.state.species}&class=host`}>
                    KEGG Pathways
                  </a>
                </li>
                <li>
                  {" "}
                  <a className="linked" href={`${env.BASE_URL}/go/?id=${this.state.species}&class=host`}>
                    Gene Ontology
                  </a>
                </li>

                <li>
                  <a className="linked" href={`${env.BASE_URL}/interpro/?id=${this.state.species}&class=host`}>
                    Functional Domains{" "}
                  </a>
                </li>
                <li>
                  <a className="linked" href={`${env.BASE_URL}/local/?id=${this.state.species}&class=host`}>
                    Subcellular Localization{" "}
                  </a>
                </li>
                <li>
                  <a className="linked" href={`${env.BASE_URL}/tf/?id=${this.state.species}&class=host`}>
                    Transcription Factors{" "}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <Divider />
        </div>
        <div className="row justify-content-center">
          <div className="col-md-3">
            <a className="btn kbl-btn-1" href={`${env.BASE_URL}/interactome/?host=${this.state.species}&pathogen=${this.state.pathogen}`} >
              Search All Interactome
            </a>
          </div>
        </div>
        <Divider />

      </div>
    )
  }
}
